import React from 'react';
import './Navtop.css';

function Navtop(){
    return(
        <div className='navtop' id='navtop'>
            <p className='navtop-text'>Limited time offer: Up to 40% off on all laptop deals!</p>
        </div>
    )
}

export default Navtop;